// Action Type for Manage License

// Get Licenses subscription list
export const GET_LICENSES_SUBSCRIPTION_LIST = "GET_LICENSES_SUBSCRIPTION_LIST";
export const GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS =
  "GET_LICENSES_SUBSCRIPTION_LIST_SUCCESS";
export const GET_LICENSES_SUBSCRIPTION_LIST_FAILURE =
  "GET_LICENSES_SUBSCRIPTION_LIST_FAILURE";

// Get Licenses subscription product list
export const GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST =
  "GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST";
export const GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS =
  "GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_SUCCESS";
export const GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE =
  "GET_LICENSES_SUBSCRIPTION_PRODUCT_LIST_FAILURE";

// Subscription Licenses Order Preview
export const REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW =
  "REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW";
export const REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS =
  "REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_SUCCESS";
export const REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE =
  "REQUEST_SUBSCRIPTION_LICENSES_ORDER_PREVIEW_FAILURE";

// Confirm Subscription Licenses Order
export const CONFIRM_SUBSCRIPTION_LICENSES_ORDER =
  "CONFIRM_SUBSCRIPTION_LICENSES_ORDER";
export const CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS =
  "CONFIRM_SUBSCRIPTION_LICENSES_ORDER_SUCCESS";
export const CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE =
  "CONFIRM_SUBSCRIPTION_LICENSES_ORDER_FAILURE";

// Update Subscription Licenses Order
export const UPDATE_SUBSCRIPTION_LICENSES_ORDER =
  "UPDATE_SUBSCRIPTION_LICENSES_ORDER";
export const UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS =
  "UPDATE_SUBSCRIPTION_LICENSES_ORDER_SUCCESS";
export const UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE =
  "UPDATE_SUBSCRIPTION_LICENSES_ORDER_FAILURE";

// Unassign License from user
export const UNASSIGN_LICENSE_FROM_USER = "UNASSIGN_LICENSE_FROM_USER";
export const UNASSIGN_LICENSE_FROM_USER_SUCCESS =
  "UNASSIGN_LICENSE_FROM_USER_SUCCESS";
export const UNASSIGN_LICENSE_FROM_USER_FAILURE =
  "UNASSIGN_LICENSE_FROM_USER_FAILURE";

///subscriptionproduct/list
export const GET_SUBSCRIPTION_PRODUCT_LIST = "GET_SUBSCRIPTION_PRODUCT_LIST";
export const GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS =
  "GET_SUBSCRIPTION_PRODUCT_LIST_SUCCESS";
export const GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE =
  "GET_SUBSCRIPTION_PRODUCT_LIST_FAILURE";

// Get all licences held by a single user (staff profile CRM Licence tab)
export const GET_USER_LICENCE_LIST = "GET_USER_LICENCE_LIST";
export const GET_USER_LICENCE_LIST_SUCCESS = "GET_USER_LICENCE_LIST_SUCCESS";
export const GET_USER_LICENCE_LIST_FAILURE = "GET_USER_LICENCE_LIST_FAILURE";
